import React, {useMemo, useState} from 'react';
import styled from 'styled-components';
import {color} from '@ey/styled-theme';
import CellItem from './CellItem';

function RowItem(props) {
	const { groupConfig, rowData, selectedItemKeys} = props;
	// const [componentRenderKey, setComponentRenderKey]  = useState(selectedItemKeys[rowData.canvasEngagementId] ? selectedItemKeys[rowData.canvasEngagementId] : props.componentRenderKey);

	// console.log('componentRenderKey' + componentRenderKey);
	const rowItem = useMemo(
		() => (
			groupConfig.render(props, rowData)
		),[rowData.canvasEngagementId, props.componentRenderKey]);
	
	return (
		<>		
			{groupConfig.render && groupConfig.render(props, rowData)}
		</>
	);
}

export default RowItem;
